import { getActivateSubscriptionData } from './activateSubscription';
import { ethAddress, zeroAddress } from 'viem';
import { encodeERC20Approval } from '../utils/encodeERC20Approval';
export async function renewMembership(args) {
    const { spaceDapp, tokenId, spaceId, signer, subscriptionConfig, smartAccount } = args;
    const space = spaceDapp?.getSpace(spaceId);
    if (!space) {
        throw new Error(`Space with spaceId "${spaceId}" is not found.`);
    }
    const spaceCurrency = await space.Membership.read.getMembershipCurrency();
    const isERC20Space = spaceCurrency.toLowerCase() !== ethAddress.toLowerCase() &&
        spaceCurrency.toLowerCase() !== zeroAddress.toLowerCase();
    if (subscriptionConfig && spaceDapp) {
        const subscriptionModuleAddress = spaceDapp.config.addresses.subscriptionModule;
        if (!subscriptionModuleAddress) {
            throw new Error('Subscription module address not found');
        }
        const { activate, entityId } = subscriptionConfig;
        // Optimizing for the case where a sub is already installed.
        // If a sub already is installed, we are able to activate + renew in a batched op
        //
        // But if a sub is not already installed, we cannot install + renew in a batched op - it results in a revert 0x1fe81382 Diamond_UnsupportedFunction see test/userops.modular.installSubscription.test.ts
        // You must first renew the membership, then install the sub.
        if (activate && entityId !== undefined) {
            const encodedActivateData = getActivateSubscriptionData({ entityId });
            const [renewMembershipToAddress, renewMembershipCalldata, renewMembershipValue] = await space.Membership.renewMembership({
                tokenId,
                signer,
                overrideExecution: async ({ toAddress, calldata, value }) => [
                    toAddress,
                    calldata,
                    value,
                ],
            });
            let renewMembershipValueBigInt = 0n;
            if (renewMembershipValue) {
                renewMembershipValueBigInt = BigInt(renewMembershipValue);
            }
            const { toAddress: actualToAddress, callData: actualCallData, value: actualValue, } = paramsWithUSDCApproval({
                toAddress: [subscriptionModuleAddress, renewMembershipToAddress],
                callData: [encodedActivateData, renewMembershipCalldata],
                value: [0n, renewMembershipValueBigInt],
                isERC20Space,
                tokenAddress: spaceCurrency,
                spender: space.Address,
                approvalAmount: renewMembershipValueBigInt,
            });
            return smartAccount.sendUserOp({
                toAddress: actualToAddress,
                callData: actualCallData,
                value: actualValue,
                functionHashForPaymasterProxy: 'renewMembership',
                spaceId,
                signer,
            });
        }
    }
    return space.Membership.renewMembership({
        tokenId,
        signer,
        overrideExecution: async ({ toAddress, calldata, value }) => {
            const { toAddress: actualToAddress, callData: actualCallData, value: actualValue, } = paramsWithUSDCApproval({
                toAddress: [toAddress],
                callData: [calldata],
                value: [value ?? 0n],
                isERC20Space,
                tokenAddress: spaceCurrency,
                spender: space.Address,
                approvalAmount: value ?? 0n,
            });
            return smartAccount.sendUserOp({
                toAddress: actualToAddress,
                callData: actualCallData,
                signer,
                spaceId,
                value: actualValue,
                functionHashForPaymasterProxy: 'renewMembership',
            });
        },
    });
}
function paramsWithUSDCApproval(params) {
    const { toAddress, callData, value, isERC20Space, tokenAddress, spender, approvalAmount } = params;
    if (isERC20Space) {
        const usdcApprovalCallData = encodeERC20Approval({
            tokenAddress,
            spender,
            amount: approvalAmount,
        });
        return {
            toAddress: [tokenAddress, ...toAddress],
            callData: [usdcApprovalCallData, ...callData],
            value: undefined,
        };
    }
    return {
        toAddress,
        callData,
        value,
    };
}
